import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {useIntl, FormattedMessage, FormattedNumber} from 'react-intl';
import { get } from '../../services/api';
import { usePageLoader } from '../../contexts/PageLoaderContext';
import { useNotifier } from '../../contexts/NotificationContext';
import Title from '../../components/common/Title/Title';
import ChartCard from '../../components/ChartCard/ChartCard';
import FullScreenMessage from '../../components/common/FullScreenMessage/FullScreenMessage';
import {FiBarChart2, FiCheck, FiEye, FiTrendingUp} from 'react-icons/fi';
import {showBackButton} from "../../services/telegramService";
import styles from './StatisticsPage.module.css';
import Card from "../../components/common/Card/Card";
import {Line} from "react-chartjs-2";

const StatisticsPage = () => {
    const intl = useIntl();
    const { formId } = useParams();
    const [stats, setStats] = useState(null); // null для начального состояния загрузки
    const { showPageLoader, hidePageLoader } = usePageLoader();
    const { addNotification } = useNotifier();
    const navigate = useNavigate();

    useEffect(() => {
        showBackButton();
    }, []);

    useEffect(() => {
        showPageLoader();
        get(`forms/${formId}/statistics`)
            .then(response => {
                if (response.data) {
                    setStats(response.data);
                }
            })
            .catch(error => {
                addNotification(error.message, 'error');
                navigate(`/form/${formId}/settings`);
            })
            .finally(() => hidePageLoader());
    }, [formId, showPageLoader, hidePageLoader, addNotification, navigate]);

    if (stats === null) {
        return null; // Показываем глобальный лоадер
    }

    const timeSeriesChartData = {
        labels: stats.time_series.labels,
        datasets: [{
            label: intl.formatMessage({ id: "formSettingsPage.stats.submissions" }),
            data: stats.time_series.values,
            fill: true,
            backgroundColor: 'rgba(54, 162, 235, 0.2)',
            borderColor: 'rgba(54, 162, 235, 1)',
            tension: 0.3,
        }]
    };

    if (stats.length === 0) {
        return (
            <div>
                <Title><FormattedMessage id="statsPage.title" /></Title>
                <FullScreenMessage
                    icon={<FiBarChart2 size={48} />}
                    title={intl.formatMessage({id: "answersPage.noAnswers"})}
                />
            </div>
        );
    }


    return (
        <div>
            <Title><FormattedMessage id="statsPage.title"/></Title>

            <h2 className={styles.sectionTitle}><FormattedMessage id="statsPage.summaryTitle"/></h2>
            <div className={styles.summaryGrid}>
                <Card className={styles.summaryCard} style={{marginBottom: 0}}>
                    <FiEye className={styles.summaryIcon}/>
                    <span className={styles.summaryValue}>{stats.summary.views_count}</span>
                    <span className={styles.summaryLabel}><FormattedMessage id="formSettingsPage.stats.views"/></span>
                </Card>
                <Card className={styles.summaryCard} style={{marginBottom: 0}}>
                    <FiCheck className={styles.summaryIcon}/>
                    <span className={styles.summaryValue}>{stats.summary.submissions_count}</span>
                    <span className={styles.summaryLabel}><FormattedMessage
                        id="formSettingsPage.stats.submissions"/></span>
                </Card>
                <Card className={styles.summaryCard} style={{marginBottom: 0}}>
                    <FiTrendingUp className={styles.summaryIcon}/>
                    <span className={styles.summaryValue}>
                        <FormattedNumber value={stats.summary.conversion_rate} style="percent"
                                         minimumFractionDigits={1}/>
                    </span>
                    <span className={styles.summaryLabel}><FormattedMessage id="formSettingsPage.stats.conversionRate"/></span>
                </Card>
            </div>

            {/* --- БЛОК ГРАФИКА ПО ДНЯМ --- */}
            <h2 className={styles.sectionTitle}><FormattedMessage id="statsPage.timeSeriesTitle"/></h2>
            <Card>
                <div className={styles.timeSeriesChartContainer}>
                    <Line data={timeSeriesChartData} options={{responsive: true, maintainAspectRatio: false}}/>
                </div>
            </Card>

            {/* --- БЛОК СТАТИСТИКИ ПО ВОПРОСАМ --- */}
            <h2 className={styles.sectionTitle}><FormattedMessage id="answersPage.title"/></h2>
            {stats.questions.map(questionStats => (
                <ChartCard key={questionStats.question_id} questionStats={questionStats}/>
            ))}
        </div>
    );
};
export default StatisticsPage;
